<template>
	<div class="accordion">
		<div
			class="accordion-header d-flex align-items-center"
			:class="[
				headerClass,
			]"
			@click="toggle"
			@mouseenter="onMouseEnter"
			@mouseleave="onMouseLeave"
			v-tooltip="tooltip ? tooltip : ''">
			<div class="accordion-left-icon"
				:class="{
					'invisible': !showArrow
				}"
				v-if="arrowPosition === 'left'">
				<i class="icon material-icons">
					<template v-if="isOpen">arrow_drop_down</template>
					<template v-else>arrow_right</template>
				</i>
			</div>
			<slot name="heading" />
			<template v-if="showArrow && arrowPosition === 'right'">
				<i class="icon material-icons ml-auto" v-if="showArrow">
					<template v-if="isOpen">arrow_drop_down</template>
					<template v-else>arrow_drop_up</template>
				</i>
			</template>
		</div>
		<div
			class="accordion-body"
			v-show="isOpen"
			@mouseenter="onMouseEnter"
			@mouseleave="onMouseLeave"
			@click="onBodyClick">
			<slot
				name="body"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Accordion',
	props: {
		title: {
			type: String,
			default: '',
		},
		showArrow: {
			type: Boolean,
			default: true,
		},
		arrowPosition: {
			type: String,
			default: 'right',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		autoClose: {
			type: Boolean,
			default: false,
		},
		openFirst: {
			type: Boolean,
			default: false,
		},
		open: {
			type: Boolean,
			default: false,
		},
		headerClass: {
			type: String,
			default: '',
		},
		tooltip: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isOpen: false,
			isOverElement: false,
		};
	},
	mounted() {
		if (this.openFirst) {
			this.isOpen = true;
		}
	},
	methods: {
		toggle() {
			if (!this.disabled) {
				this.isOpen = !this.isOpen;
				this.$emit('toggle-click', this.isOpen);
			}
		},
		handleClick() {
			if (this.autoClose && !this.isOverElement && this.isOpen) {
				this.isOpen = !this.isOpen;
			}
		},
		onMouseEnter() {
			this.isOverElement = true;
		},
		onMouseLeave() {
			this.isOverElement = false;
		},
		onBodyClick() {
			this.isOverElement = true;
		},
	},
	created() {
		window.addEventListener('click', this.handleClick);
	},
	destroyed() {
		window.removeEventListener('click', this.handleClick);
	},
	watch: {
		open() {
			this.isOpen = this.open;
		},
	},
};
</script>

<style lang="scss" scoped>
.accordion {
	position: relative;
	width: 100%;
	background: #fff;
	border-top: 1px solid #ddd;
	border-bottom: 0;
	border-right: 1px solid #ddd;
	border-left: 1px solid #ddd;
}

.accordion-header {
	padding: 10px;
	background: #f5f5f5;
	// border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	cursor: pointer;
}

.accordion-body {
	padding: 10px;
	border-bottom: 1px solid #ddd;
}

.accordion-left-icon {
	opacity: 1;

	i {
		margin-bottom: 4px;
	}

	&.invisible {
		opacity: .5;
	}
}
</style>
